// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("BonnerCountyLogo-75.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("BonnerCountyLogo-45.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://js.arcgis.com/5.0/@arcgis/core/assets/esri/themes/light/main.css);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: rgb(246, 246, 246);
}

#header {
    background-color: #325674;
    height: 15vh;
    width: 60vw;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

.header-title{
    color: white;
    margin: 0;
    font-size: 24px;
    font-weight: bold;
}

.header-subtitle{
    color: white;
    margin: 0;
    font-size: 18px;
}

#header h1, h4{
    color: white;
    margin: 0;
}

#header-table{
    margin: auto;
}

.bc-logo {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    margin-right: 50px;
}

main[role=main]{
    margin: auto;
    width: 60vw;
}

#mainContent-inner {
    background-color: rgb(255, 255, 255);
    min-height: 500px;
    border: 1px solid rgb(140, 140, 140);
}

#mainContent-inner-searchtools {
    text-align: center;
    height: auto;
    padding: 10px 10px 10px 10px;
}

#search-box {
    width: 80%;
    margin: auto;
    height: 25px;
}

#search-box:focus {
    color: #495057;
    background-color: #fff;
    border-color: #37383d;
    outline: transparent;
    box-shadow: none;
}

#search-button {
    margin-left: 10px;
    font-size: 16px;
    cursor: pointer;
}
#search-button[disabled] {
    cursor: default;
}

#resultsDiv{
    overflow-y: auto;
    max-height: 65vh;
    margin: auto;
    width: 85%;
}

#total-features-found{
    font-size: 12px;
    margin: auto;
    width: 85%;
}

#resultsTable{
    border-collapse: collapse;
    table-layout: fixed;
    max-width: 100%;
}

#resultsTable .tr-header{
    border-top: 1px solid rgb(228, 228, 228);
    background-color: rgb(246, 246, 246);
    color: #325674;
    font-size: 16px;
}

#resultsTable .td-header{
    width: auto;
    padding: 0 40px 0 10px;
}

#resultsTable .td-info{
    font-size: 14px;
    padding: 0 40px 0 10px;
    word-wrap:break-word;
}

.record-button{
    background-color: #325674;
    color: #FFFFFF;
    border: none;
    border-radius: 2px;
    cursor: pointer;
    padding: 5px;
    outline: transparent;
}

.record-button:hover{
    background-color: #005e95;
    background-color: rgba(50, 86, 116, 0.5);
}
@media (width <= 1300px){
    #header {
        height: 10vh;
        width: 90vw;
    }
    .bc-logo{
        content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
        margin-right: 5px;
    }
    .header-title{
        color: white;
        margin: 0;
        font-size: 16px;
        font-weight: bold;
    }
    
    .header-subtitle{
        color: white;
        margin: 0;
        font-size: 14px;
    }
    main[role=main]{
        margin: auto;
        width: 90vw;
    }

    #resultsTable .tr-header{
        border-top: 1px solid rgb(228, 228, 228);
        background-color: rgb(246, 246, 246);
        color: #325674;
        font-size: 12px;
        /* white-space: wrap; */
    }
    
    #resultsTable .td-header{
        padding: 0;
    }
    
    #resultsTable .td-info{
        font-size: 10px;
        padding: 0;
    }

    .record-button{
        font-size: 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gDAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;AAC5C;AACA;IACI;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,gDAAuC;QACvC,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,SAAS;QACT,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,SAAS;QACT,eAAe;IACnB;IACA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,wCAAwC;QACxC,oCAAoC;QACpC,cAAc;QACd,eAAe;QACf,uBAAuB;IAC3B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;QACf,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["@import \"https://js.arcgis.com/5.0/@arcgis/core/assets/esri/themes/light/main.css\";\r\n\r\nbody {\r\n    background-color: rgb(246, 246, 246);\r\n}\r\n\r\n#header {\r\n    background-color: #325674;\r\n    height: 15vh;\r\n    width: 60vw;\r\n    margin: auto;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.header-title{\r\n    color: white;\r\n    margin: 0;\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n}\r\n\r\n.header-subtitle{\r\n    color: white;\r\n    margin: 0;\r\n    font-size: 18px;\r\n}\r\n\r\n#header h1, h4{\r\n    color: white;\r\n    margin: 0;\r\n}\r\n\r\n#header-table{\r\n    margin: auto;\r\n}\r\n\r\n.bc-logo {\r\n    content: url(\"BonnerCountyLogo-75.png\");\r\n    margin-right: 50px;\r\n}\r\n\r\nmain[role=main]{\r\n    margin: auto;\r\n    width: 60vw;\r\n}\r\n\r\n#mainContent-inner {\r\n    background-color: rgb(255, 255, 255);\r\n    min-height: 500px;\r\n    border: 1px solid rgb(140, 140, 140);\r\n}\r\n\r\n#mainContent-inner-searchtools {\r\n    text-align: center;\r\n    height: auto;\r\n    padding: 10px 10px 10px 10px;\r\n}\r\n\r\n#search-box {\r\n    width: 80%;\r\n    margin: auto;\r\n    height: 25px;\r\n}\r\n\r\n#search-box:focus {\r\n    color: #495057;\r\n    background-color: #fff;\r\n    border-color: #37383d;\r\n    outline: transparent;\r\n    box-shadow: none;\r\n}\r\n\r\n#search-button {\r\n    margin-left: 10px;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n}\r\n#search-button[disabled] {\r\n    cursor: default;\r\n}\r\n\r\n#resultsDiv{\r\n    overflow-y: auto;\r\n    max-height: 65vh;\r\n    margin: auto;\r\n    width: 85%;\r\n}\r\n\r\n#total-features-found{\r\n    font-size: 12px;\r\n    margin: auto;\r\n    width: 85%;\r\n}\r\n\r\n#resultsTable{\r\n    border-collapse: collapse;\r\n    table-layout: fixed;\r\n    max-width: 100%;\r\n}\r\n\r\n#resultsTable .tr-header{\r\n    border-top: 1px solid rgb(228, 228, 228);\r\n    background-color: rgb(246, 246, 246);\r\n    color: #325674;\r\n    font-size: 16px;\r\n}\r\n\r\n#resultsTable .td-header{\r\n    width: auto;\r\n    padding: 0 40px 0 10px;\r\n}\r\n\r\n#resultsTable .td-info{\r\n    font-size: 14px;\r\n    padding: 0 40px 0 10px;\r\n    word-wrap:break-word;\r\n}\r\n\r\n.record-button{\r\n    background-color: #325674;\r\n    color: #FFFFFF;\r\n    border: none;\r\n    border-radius: 2px;\r\n    cursor: pointer;\r\n    padding: 5px;\r\n    outline: transparent;\r\n}\r\n\r\n.record-button:hover{\r\n    background-color: #005e95;\r\n    background-color: rgba(50, 86, 116, 0.5);\r\n}\r\n@media (width <= 1300px){\r\n    #header {\r\n        height: 10vh;\r\n        width: 90vw;\r\n    }\r\n    .bc-logo{\r\n        content: url(\"BonnerCountyLogo-45.png\");\r\n        margin-right: 5px;\r\n    }\r\n    .header-title{\r\n        color: white;\r\n        margin: 0;\r\n        font-size: 16px;\r\n        font-weight: bold;\r\n    }\r\n    \r\n    .header-subtitle{\r\n        color: white;\r\n        margin: 0;\r\n        font-size: 14px;\r\n    }\r\n    main[role=main]{\r\n        margin: auto;\r\n        width: 90vw;\r\n    }\r\n\r\n    #resultsTable .tr-header{\r\n        border-top: 1px solid rgb(228, 228, 228);\r\n        background-color: rgb(246, 246, 246);\r\n        color: #325674;\r\n        font-size: 12px;\r\n        /* white-space: wrap; */\r\n    }\r\n    \r\n    #resultsTable .td-header{\r\n        padding: 0;\r\n    }\r\n    \r\n    #resultsTable .td-info{\r\n        font-size: 10px;\r\n        padding: 0;\r\n    }\r\n\r\n    .record-button{\r\n        font-size: 12px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
